import { HttpErrorResponse } from '@angular/common/http';

export type SyncOperation = 'create' | 'delete' | 'picture';
export type SyncOutcome = 'done' | 'retry' | 'auth' | 'failed';

export function classifySyncError(error: unknown, operation: SyncOperation): SyncOutcome {
  if (!(error instanceof HttpErrorResponse)) return 'failed';
  const status = error.status;
  if (status === 0 || status >= 500 || status === 408 || status === 429) return 'retry';
  if (status === 401) return 'auth';
  if (status === 404 && operation === 'delete') return 'done';
  return 'failed';
}

export function syncErrorMessage(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    const body = error.error as { error?: string; message?: string } | null;
    return body?.error || body?.message || error.message;
  }
  if (error instanceof Error) return error.message;
  return String(error);
}

export function serverErrorMessage(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    const body = error.error as { error?: string; message?: string } | null;
    return body?.error || body?.message || '';
  }
  return '';
}
